/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_MenuInputs */

const en_pwf_menu = /** @type {(inputs: Pwf_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow`)
};

const de_pwf_menu = /** @type {(inputs: Pwf_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow`)
};

/**
* | output |
* | --- |
* | "Workflow" |
*
* @param {Pwf_MenuInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_menu = /** @type {((inputs?: Pwf_MenuInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_MenuInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_menu(inputs)
	return en_pwf_menu(inputs)
});